import {
  FormGroup,
  AbstractControl,
  FormGroupDirective,
  FormArray,
  AsyncValidatorFn,
  ValidatorFn,
} from "@angular/forms";
import { Subject, Observable } from "rxjs";
import { FieldType } from "../templates/field.type";
import {
  TemplateManipulators,
  ValidationMessageOption,
} from "../services/kre-form.config";
import {
  ComponentFactoryResolver,
  ComponentRef,
  Injector,
} from "@angular/core";

export interface KreFormInfo {
  code?: string;
  name?: string;
  type?: string;
  layout?: string;
  column?: string;
  row?: string;
  fields?: KreFormFieldConfig[];
}

export interface KreSurveyInfo {
  code?: string;
  name?: string;
  type?: string;
  first?: any;
  last?: any;
  pages?: KreSurveyPage[];
}

export interface KreSurveyPage {
  code?: string;
  name?: string;
  questions?: KreFormFieldConfig[];
}

export interface KreParameterData {
  label?: string;
  value?: string;
}

export interface KreTableConfig {
  tableCode?: string;
  tableName?: string;
  tableFields?: KreTableFieldConfig[];
  tableQuote?: boolean;
  secondType?: string;
}

export interface KreTableFieldConfig {
  tableCode?: string; //表
  fieldCode?: string; //字段key
  fieldName?: string; //字段label
  dataType?: string; //数据类型
  selectType?: "" | "single" | "multiple"; //选择类型
  showType?: "" | "select" | "radio" | "checkbox"; //针对常用参数的显示样式    下拉、单选组、复选组、开关
  secondType?: string;
  allowNull?: boolean; //是否必填;
  placeholder?: string; //占位符
  maxLength?: number; //最大长度
  minLength?: number; //最小长度
  max?: number; //最大值
  min?: number; //最小值
  maxDate?: string; //最大值
  minDate?: string; //最小值
  precision?: number; //精度;
  accuracy?: number; //精度;
  isDisable?: boolean;
  readonly?: boolean;
  defaultValue?: any;
  defaultText?: any;

  parameterId?: string; //常用参数;
  parameterData?: KreParameterData[];

  /* 额外的属性 */
  //隐藏
  hidden?: boolean;

  tips?: string;
  //固有的
  isButintin?: boolean;
  pattern?: string | RegExp;

  format?: string;
}

export interface KreFormFieldRole {
  key: string;
  show?: boolean;
  editor?: boolean;
  required?: boolean;
  enableInterface?: boolean;
  modalField?: any[];
  tags?: any;
  [additionalProperties: string]: any;
}

export interface KreFormFieldOption {
  label?: string;
  value?: any;
}

export interface KreAttachment {
  //附件大小
  size?: number;
  //附件数量
  limit?: number;
  //附件类型
  type?: string;
}

export interface KreAttachmentFile {
  uid?: string;
  name?: string;
  url?: string;
}
export interface IKreDesgin {
  edit?: boolean;
  delete?: boolean;
}

export interface ITemplateButton {
  label?: string;
  show?: boolean;
}

export interface IEditProperty {
  delete?: boolean;
  config?: boolean;

  [additionalProperties: string]: any;

  label?: boolean;
  require?: boolean;
  font?: boolean;
}

export interface IFontProperty {
  [additionalProperties: string]: any;
  color?: string;
  fontSize?: number;
  fontWeight?: boolean;
  fontStyle?: boolean;
}
export interface IPrimitiveProperty {
  //原始最大值
  max?: number;
  //原始最小值
  min?: number;
  //精度
  precision?: number;
  //原始最小长度
  minLength?: number;
  //原始最大长度
  maxLength?: number;
  maxDate?: string;
  minDate?: string;
}
export interface IOperationProperty {
  canAdd?: boolean;
  canDelete?: boolean;
  [key: string]: any;
}

export interface KreFormFieldConfig {
  readonly model?: any;
  readonly parent?: KreFormFieldConfig;
  readonly options?: KreFormOptions;
  readonly form?: FormGroup;

  //唯一标识
  key?: any;
  //组件类型
  type?: string;
  //属性描述对象
  templateOptions?: KreFormTemplateOptions;
  //属性描述
  editProperty?: IEditProperty;
  fontProperty?: IFontProperty;
  operationProperty?: IOperationProperty;
  primitiveProperty?: IPrimitiveProperty;
  //关联安装流程名称
  referProcessList?: Array<{ label: string; value: string }>;

  repeatRole?: any;

  //暂时不用
  guid?: string;
  //表名
  tableCode?: string;
  //是否显示
  show?: boolean;
  //是否可以编辑
  editor?: boolean;
  //默认值
  defaultValue?: any;
  //默认值文本
  defaultText?: any;
  //分组
  fieldGroup?: KreFormFieldConfig[];
  //分组数据集
  fieldArray?: KreFormFieldConfig;

  id?: string;

  name?: string;

  optionsTypes?: string[];

  validation?: {
    messages?: {
      [messageProperties: string]: ValidationMessageOption["message"];
    };
    show?: boolean;
    [additionalProperties: string]: any;
  };

  validators?: any;

  asyncValidators?: any;

  template?: string;

  wrappers?: string[];

  hide?: boolean;

  hideExpression?:
    | boolean
    | string
    | ((model: any, formState: any, field?: KreFormFieldConfig) => boolean);

  expressionProperties?: {
    [property: string]:
      | string
      | ((model: any, formState: any, field?: KreFormFieldConfig) => any)
      | Observable<any>;
  };

  formControl?: AbstractControl;

  className?: string;

  fieldGroupClassName?: string;

  focus?: boolean;

  modelOptions?: {
    debounce?: {
      default: number;
    };
    updateOn?: "change" | "blur" | "submit";
  };

  hooks?: KreFormLifeCycleOptions<KreFormHookFn>;

  lifecycle?: KreFormLifeCycleOptions;

  parsers?: ((value: any) => {})[];

  status?: number;

  checked?: boolean;

  typeold?: string;

  active?: boolean;

  rowNumber?: number;

  setting?: any;

  design?: IKreDesgin;

  hideLabel?: boolean;
  tableType?: string;
  fieldType?: string;
  fieldDataType?: string;
  tableName?: string;
  queryInfo?: {
    [key: string]: any;
  };
}

export interface ExpressionPropertyCache {
  expression: (
    model: any,
    formState: any,
    field: KreFormFieldConfigCache
  ) => boolean;
  expressionValue?: any;
}

export interface KreFormFieldConfigCache extends KreFormFieldConfig {
  parent?: KreFormFieldConfigCache;
  options?: KreFormOptionsCache;
  _expressionProperties?: { [property: string]: ExpressionPropertyCache };
  resetOnHide?: boolean;
  _hide?: boolean;
  _validators?: ValidatorFn[];
  _asyncValidators?: AsyncValidatorFn[];
  _componentRefs?: ComponentRef<FieldType>[];
  _keyPath?: {
    key: KreFormFieldConfig["key"];
    path: string[];
  };
}

export type KreFormAttributeEvent = (
  field: KreFormFieldConfig,
  event?: any
) => void;

export interface KreFormTemplateOptions {
  //二次扩展的类型
  type?: string;
  //字段Label
  label?: string;
  labelI18n?: any[];
  lang?: string;

  //占位符
  placeholder?: string;
  //选项数据集[{label:"",value:""}]
  options?: any[] | Observable<any[]>;
  //单选|多选
  selectType?: "" | "single" | "multiple";
  //提示
  tips?: string;
  tipsI18n?: any[];

  //是否内置
  isButintin?: boolean;
  //格式化
  format?: string;
  //行数
  rows?: number;
  //列数
  cols?: number;
  //是否隐藏
  hidden?: boolean;
  //是否必填
  required?: boolean;
  //最大值
  max?: number;
  //最小值
  min?: number;

  //精度
  precision?: number;

  //最小长度
  minLength?: number;
  //最大长度
  maxLength?: number;

  //正则表达式
  pattern?: string | RegExp;

  //关联字段
  relation?: any;
  //是否开启
  isChecked?: boolean;

  isNav?: boolean;
  index?: number;
  pIndex?: number;

  enableInterface?: boolean;
  modalField?: any;

  parameterId?: string;

  hideSelect?: any[] | null;

  tags?: any;

  filetype?: string;
  filesize?: string;
  fileaction?: string;
  attachment?: KreAttachment;
  attachmentfile?: KreAttachmentFile[];

  unit?: string;
  button?: ITemplateButton;
  disabled?: boolean;
  description?: string;
  tabindex?: number;
  readonly?: boolean;
  attributes?: { [key: string]: string | number };
  step?: number;
  switchOption?: { checked?: string; unchecked?: string };
  focus?: KreFormAttributeEvent;
  blur?: KreFormAttributeEvent;
  keyup?: KreFormAttributeEvent;
  keydown?: KreFormAttributeEvent;
  click?: KreFormAttributeEvent;
  change?: KreFormAttributeEvent;
  keypress?: KreFormAttributeEvent;
  templateManipulators?: TemplateManipulators;
  [additionalProperties: string]: any;
  langTips?: any[];
  langPlaceholder?: [];
  //最小日期
  maxDate?: string;
  //最大日期
  minDate?: string;
  errorMsg?: string;
  showFieldButton?: boolean;

  // 日期格式 是否显示页脚今天
  today?: boolean;

  // nzAllowClear
  clear?: boolean;
  style?: {
    color?: string;
    "font-size"?: string;
    [key: string]: string;
  };
}

export interface KreFormLifeCycleFn {
  (
    form?: FormGroup,
    field?: KreFormFieldConfig,
    model?: any,
    options?: KreFormOptions
  ): void;
}

export interface KreFormHookFn {
  (field?: KreFormFieldConfig): void;
}

export interface KreFormLifeCycleOptions<T = KreFormLifeCycleFn> {
  onInit?: T;
  onChanges?: T;
  afterContentInit?: T;
  afterViewInit?: T;
  onDestroy?: T;
  [additionalProperties: string]: any;

  /** @deprecated */
  doCheck?: T;

  /** @deprecated */
  afterContentChecked?: T;

  /** @deprecated */
  afterViewChecked?: T;
}

export interface KreFormOptionsCache extends KreFormOptions {
  _checkField?: (field: KreFormFieldConfigCache, ignoreCache?: boolean) => void;
  _markForCheck?: (field: KreFormFieldConfigCache) => void;
  _buildForm?: () => void;
  _buildField?: (field: KreFormFieldConfigCache) => KreFormFieldConfigCache;
  _resolver?: ComponentFactoryResolver;
  _injector?: Injector;
  _hiddenFieldsForCheck?: KreFormFieldConfigCache[];
  _initialModel?: any;
}
export interface KreFormOptions {
  updateInitialValue?: () => void;
  resetModel?: (model?: any) => void;
  formState?: any;
  fieldChanges?: Subject<KreFormValueChangeEvent>;
  fieldTransform?: (
    fields: KreFormFieldConfig[],
    model: any,
    form: FormGroup | FormArray,
    options: KreFormOptions
  ) => KreFormFieldConfig[];
  showError?: (field: FieldType) => boolean;
  parentForm?: FormGroupDirective | null;
}

export interface KreFormValueChangeEvent {
  field: KreFormFieldConfig;
  type: string;
  value: any;
  [meta: string]: any;
}

export enum EditType {
  false = "不可编辑",
  true = "可编辑",
}
export enum HideType {
  true = "隐藏",
  false = "显示",
}
export enum RequireType {
  false = "不必填",
  true = "必填",
}

export enum TableType {
  "single" = "单记录",
  "multiple" = "多记录",
}
export enum FieldBasicType {
  "anchor" = "锚点",
  "button" = "按钮",
  "checkbox" = "复选框",
  "text" = "文本",
  "texti18n" = "多语言",
  "textarea" = "多行文本",
  "numbers" = "数字输入",
  "password" = "密码",
  "radio" = "单选框",
  "radiogroup" = "单选框组",
  "checkboxgroup" = "复选框组",
  "select" = "选择器",
  "datetime" = "时间控件",
  "datetime-year" = "选择年控件",
  "datetime-month" = "选择月控件",
  "datetime-date" = "选择日控件",
  "datetime-time" = "选择时分控件",
  "datetime-datetime" = "选择年月日时分控件",

  "image" = "图片",
  "upload" = "附件控件",
  "htmlcontent" = "文本片段",
  "line" = "分割线",
  "drag-drop" = "拖拽",
  "group" = "组",
  "repeat" = "多记录",
  "panel" = "组",
  "employee" = "人员选择控件",
  "candidate" = "候选人选择控件",
  "sponsor" = "发起人选择控件",
  "position" = "职位选择控件",
  "tree" = "树形选择控件",
  "organizational" = "组织选择控件",
  "area" = "区域选择控件",
  "job" = "职能选择控件",
  "table" = "表格",
  "lookup" = "通用复杂选择控件",
  "textBtn" = "文本按钮",
  "adjustReportTo" = "调整汇报人选择控件",
  "refer" = "引用选择控件",
  "avatar" = "头像",
  "salary" = "调薪",
  "editor" = "富文本",
  "dimissContract" = "离职合同",
  "tabular" = "加班控制",
  "tabularItem" = "加班子项",
}

export enum initValueType {
  selected = "选中选项值",
  selectIsNull = "选项值为空",
  selectAny = "任意选项值",

  inputIsNull = "为空",
  inputIsFill = "不为空",
  inputIsSpec = "特定值",
}

export enum changeType {
  valueChange = "值变更",
  editState = "编辑状态变更",
  requireState = "必填状态变更",
  hideState = "隐藏选项值",
  showState = "提供选项值",

  limitLength = "限定字符长度",
}

export enum EventEditType {
  edit = "可编辑",
  readOnly = "只读",
  hide = "隐藏",
  show = "显示",
}

export enum EventRequiredType {
  required = "必填",
  notRequired = "不必填",
}

export enum EventIncludesType {
  includes = "包含",
  notIncludes = "不包含",
}

export interface Trigger {
  selected: string;
  fieldType: string;
  fieldName: string;

  selectItem: Array<{ label: string; value: string }>;
  selectItems: string[];
  fieldKey: string;
  changeFieldType: string;
  changeFieldName: string;
  changeAction: Array<{ label: string; value: string }>;
  changeActions: string;
  changeToItem: Array<{ label: string; value: string }>;
  changeToItems: string[];

  maxLength: number;
  maxLengthIncludes: string;

  maxIncludes: string;
  max: number;
  minLength: number;
  minLengthIncludes: string;

  minIncludes: string;
  min: number;
  specValue: string;
}

export interface Default {
  single: string | number;
  lookup: Array<{ label: string; value: string }>;
  repeatKey: {
    single: string | number;
    lookup: Array<{ label: string; value: string }>;
  };
}

export interface IItem {
  label: string;
  value: string;
}

export interface IParameterIdItem extends IItem {
  parameterId: string;
}
